import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { Navbar, Nav, Container, Offcanvas } from 'react-bootstrap';
import { Link as ScrollLink } from 'react-scroll';
import { HiMenu } from 'react-icons/hi';

import logo from "src/assets/images/navbar/logo.webp";
import { isRTL } from 'src/utils/global';
import styles from './styles.module.css';

const ICON_SIZE = 22;

const NavSmall = () => {
    const { t } = useTranslation("common");
    const [show, setShow] = useState<boolean>(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const linkClassName = `${styles.item__link} nav-link`;

    return (
        <header>
            <Navbar expand={false} className={`${styles.nav} ${styles.nav__sm} ${isRTL() && styles.rtl}`}>
                <Container>

                    {/* Logo */}
                    <Navbar.Brand className={styles.nav_brand} href="/">
                        <img src={logo} alt={t("nav.title")} className={styles.logo_img} />
                    </Navbar.Brand>

                    {/* Hamburger Toggle */}
                    <Navbar.Toggle
                        className={styles.toggle}
                        aria-controls="offcanvasNavbar-expand-xl"
                        onClick={handleShow}
                    >
                        <HiMenu size={ICON_SIZE + 4} />
                    </Navbar.Toggle>

                    <Navbar.Offcanvas
                        id="offcanvasNavbar-expand-xl"
                        aria-labelledby="offcanvasNavbarLabel-expand-xl"
                        placement={isRTL() ? "start" : "end"}
                        show={show}
                        onHide={handleClose}
                        className={`${styles.sm__offcanvas} ${isRTL() && styles.rtl__offcanvas}`}
                    >
                        <Offcanvas.Header closeButton className={styles.offcanvas__header}>
                            <Offcanvas.Title>
                                <img src={logo} alt={t("store_name")} height={50} width={123} />
                            </Offcanvas.Title>
                        </Offcanvas.Header>

                        <Offcanvas.Body className={styles.offcanvas__body}>
                            <Nav className="justify-content-end flex-grow-1">

                                {/* HOME */}
                                <a
                                    href="/"
                                    className={linkClassName}
                                    onClick={handleClose}
                                >
                                    {t("nav.home")}
                                </a>

                                {/* ABOUT */}
                                <ScrollLink
                                    to="aboutUs"
                                    smooth={true}
                                    duration={500}
                                    offset={-80}
                                    className={linkClassName}
                                    onClick={handleClose}
                                >
                                    {t("nav.about")}
                                </ScrollLink>

                                {/* SERVICES */}
                                <ScrollLink
                                    to="services"
                                    smooth={true}
                                    duration={500}
                                    offset={-80}
                                    className={linkClassName}
                                    onClick={handleClose}
                                >
                                    {t("nav.services")}
                                </ScrollLink>

                                {/* CONTACT */}
                                <a
                                    target="_blank"
                                    href="https://wa.me/218913756968"
                                    className={linkClassName}
                                    onClick={handleClose}
                                >
                                    {t("nav.contact")}
                                </a>

                            </Nav>
                        </Offcanvas.Body>
                    </Navbar.Offcanvas>

                </Container>
            </Navbar>

            <div className={styles.prop}></div>
        </header>
    );
}

export default NavSmall;
